import { ChangeDetectorRef, Component, ComponentRef, ElementRef, EventEmitter, Output, Renderer2, ViewChild, ViewContainerRef, HostListener } from '@angular/core';
import { PopupComponent } from './popup.component';

@Component({
    selector: 'window',
    templateUrl: './window.component.html',
    styleUrls: ['./window.component.less']
})
export class WindowComponent extends PopupComponent {

    title: string = '';

    protected windowContentBody: any;

    topMargin: number = 10;

    showClose: boolean = false;

    @Output() crossclick: EventEmitter<any> = new EventEmitter();
    getOnCrossClose(): EventEmitter<any> {

        return this.crossclick;

    }

    @ViewChild('body', { read: ViewContainerRef, static: true })
    bodyViewRef: ViewContainerRef | null = null;

    bodyComponent: ComponentRef<any> | null = null;

    getBodyComponent(): any {

        return this.bodyComponent ? this.bodyComponent?.instance : null;

    }

    constructor(element: ElementRef,
        r: Renderer2,
        viewContainerRef: ViewContainerRef,
        chDet: ChangeDetectorRef
    ) {
        super(element, r, viewContainerRef, chDet);
    }

    protected init(): void {

        if (!this.bodyComponent && this.bodyViewRef) {

            let ref = this.bodyViewRef.createComponent(this.windowContentBody);

            this.bodyComponent = ref;
        }
    }

    protected ngOnInit() {

        this.init();

        this.afterinit.emit();

    }

    @HostListener('window:resize', ['$event'])
    handleResize(ev: Event): void {
        // some formal features to detect confirming dialogs or full-screen windows
        if ((!this.isModal || this.getYPos() === 0) && this.title.length < 1)
            this.changeWinSize();
        else
            this.changeWinPosition();
    }

    private changeWinPosition() {
        const newW = document.body.clientWidth;
        const newH = document.body.clientHeight;

        const xPos = newW / 2 - this.getWidth() / 2;
        const yPos = newH / 2 - this.getHeight() / 2;

        if (!xPos || !yPos)
            return;

        this.setPosition(xPos, yPos);

        this.setBrowserWidth(newW);
        this.setBrowserHeight(newH);
    }

    private changeWinSize() {
        if (!this.isFullScreenWindow())
            return

        const newW = document.body.clientWidth;
        const newH = document.body.clientHeight;

        const elem = this.getElDom();

        this.r.setStyle(elem, 'width', newW + 'px');
        this.r.setStyle(elem, 'height', newH + 'px');

        this.setWidth(newW);
        this.setHeight(newH);
        this.setBrowserWidth(newW);
        this.setBrowserHeight(newH);
    }

    private isFullScreenWindow(): boolean {
        const prevWindowWidth = this.getBrowserWidth();
        const prevWindowHeight = this.getBrowserHeight();
        const prevElemWidth = this.getWidth();
        const prevElemHeight = this.getHeight();

        return (this.getXPos() == 0 &&
            this.getYPos() == 0 &&
            this.approximatelyEquals(prevElemWidth, prevWindowWidth) &&
            this.approximatelyEquals(prevElemHeight, prevWindowHeight));
    }

    private approximatelyEquals(comparedValue: number, compareWith: number): boolean {
        // for monitors with scaling
        return (comparedValue == compareWith) ||
            (comparedValue > compareWith - 1 && comparedValue < compareWith + 1);
    }
}
